import { render, staticRenderFns } from "./PatientDetailPerson.vue?vue&type=template&id=3d1172b6&scoped=true"
import script from "./PatientDetailPerson.vue?vue&type=script&lang=js"
export * from "./PatientDetailPerson.vue?vue&type=script&lang=js"
import style0 from "./PatientDetailPerson.vue?vue&type=style&index=0&id=3d1172b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1172b6",
  null
  
)

export default component.exports